import { useState } from "react";
import { Button, Drawer } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const NavBar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { language, toggleLanguage } = useLanguage();

  // Framer Motion Variants
  const navbarAnimation = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <motion.header
      variants={navbarAnimation}
      initial="hidden"
      animate="visible"
      className="fixed top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 "
    >
      <div className="flex h-16 w-full items-center justify-between px-4 lg:px-8">
        {/* Logo */}
        <a href="#Home" className="flex items-center">
          <img src="./rdy.png" alt="Logo" className="w-10 h-10" />
          <span className="text-2xl font-bold text-black ml-2 font-sablon">
            Reebaq
          </span>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-6">
          <a href="#Home" className="text-sm font-medium">
            {language === "de" ? "Home" : "Home"}
          </a>
          <a href="#About" className="text-sm font-medium">
            {language === "de" ? "Über uns" : "About us"}
          </a>
          <a href="#How-it-works" className="text-sm font-medium">
            {language === "de" ? "Wie funktioniert das?" : "How it works"}
          </a>
          <a href="#Pricing" className="text-sm font-medium">
            {language === "de" ? "Preise" : "Pricing"}
          </a>
          <a href="#FAQ" className="text-sm font-medium">
            {language === "de" ? "FAQ" : "FAQ"}
          </a>

          {/* Blog Link - abgesetzt */}
          <div className="border-l border-gray-300 pl-6 ml-2">
            <a
              href="/blog"
              className="text-sm font-medium hover:text-[#FF7051] transition-colors"
              onClick={() => navigate("/blog")}
            >
              Blog
            </a>
          </div>

          {/* Language Toggle Button */}
          <Button
            onClick={toggleLanguage}
            className="px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm"
          >
            {language === "de" ? "EN" : "DE"}
          </Button>
        </nav>

        {/* Desktop Button */}
        <div className="hidden lg:flex items-center space-x-4 mr-4">
          <Button
            className="bg-[#FF7051] text-white hover:bg-[#FF7051]/90"
            onClick={() => navigate("/login")}
          >
            {language === "de" ? "Loslegen" : "Get started"}
          </Button>
        </div>

        {/* Hamburger Menu Button for Mobile */}
        <button
          className="flex items-center lg:hidden text-xl"
          onClick={() => setDrawerOpen(true)}
        >
          <MenuOutlined />
        </button>
      </div>

      {/* Mobile Drawer */}
      <Drawer
        title={language === "de" ? "Navigation" : "Navigation"}
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
      >
        <nav className="flex flex-col space-y-4">
          <a
            href="#Home"
            className="text-sm font-medium"
            onClick={() => setDrawerOpen(false)}
          >
            {language === "de" ? "Home" : "Home"}
          </a>
          <a
            href="#About"
            className="text-sm font-medium"
            onClick={() => setDrawerOpen(false)}
          >
            {language === "de" ? "Über uns" : "About us"}
          </a>
          <a
            href="#How-it-works"
            className="text-sm font-medium"
            onClick={() => setDrawerOpen(false)}
          >
            {language === "de" ? "Wie funktioniert das?" : "How it works"}
          </a>
          <a
            href="#Pricing"
            className="text-sm font-medium"
            onClick={() => setDrawerOpen(false)}
          >
            {language === "de" ? "Preise" : "Pricing"}
          </a>
          <a
            href="#FAQ"
            className="text-sm font-medium"
            onClick={() => setDrawerOpen(false)}
          >
            {language === "de" ? "FAQ" : "FAQ"}
          </a>

          {/* Blog Link im Drawer - mit Trennlinie */}
          <div className="border-t border-gray-200 pt-4">
            <a
              href="/blog"
              className="text-sm font-medium"
              onClick={() => {
                setDrawerOpen(false);
                navigate("/blog");
              }}
            >
              Blog
            </a>
          </div>

          {/* Language Toggle Button im Drawer */}
          <Button
            onClick={toggleLanguage}
            className="px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded text-sm"
          >
            {language === "de" ? "EN" : "DE"}
          </Button>
        </nav>
        <div className="mt-4">
          <Button
            className="bg-[#FF7051] text-white hover:bg-[#FF7051]/90 w-full"
            onClick={() => navigate("/login")}
          >
            {language === "de" ? "Loslegen" : "Get started"}
          </Button>
        </div>
      </Drawer>
    </motion.header>
  );
};

export default NavBar;
